// Procenta pro lidi: jedno desetinné místo, česká čárka (42,857142… → „42,9“).
// Uložená hodnota může mít víc desetin (přesná marže z importu) — jen se tak nevypisuje.
export function fmtPct(n) {
  if (n === null || n === undefined || n === "" || !Number.isFinite(Number(n))) return "—";
  return String(Math.round(Number(n) * 10) / 10).replace(".", ",");
}

export function fmtKc(n) {
  const v = Math.round(Number(n) || 0);
  return new Intl.NumberFormat("cs-CZ").format(v).replace(/\u00A0/g, " ");
}

/** Zkrácená částka do karet a sloupců: 4,7 mil. Kč · 680 tis. Kč · 9 500 Kč (nezlomitelné mezery).
    Nula je platná hodnota (0 Kč), pomlčka jen pro chybějící. */
export function fmtKcKratce(n) {
  if (n === null || n === undefined) return "—";
  const v = Number(n) || 0;
  const a = Math.abs(v);
  const NB = "\u00A0";
  if (a >= 999500) return `${String(Math.round(v / 1e5) / 10).replace(".", ",")}${NB}mil.${NB}Kč`;
  if (a >= 10000) return `${Math.round(v / 1000)}${NB}tis.${NB}Kč`;
  return `${fmtKc(v).replace(/ /g, NB)}${NB}Kč`;
}

export function fmtDate(d) {
  if (!d) return "—";
  return new Intl.DateTimeFormat("cs-CZ", { day: "numeric", month: "numeric", year: "numeric" }).format(new Date(d));
}

export function fmtDateTime(d) {
  if (!d) return "—";
  return new Intl.DateTimeFormat("cs-CZ", {
    day: "numeric", month: "numeric", hour: "2-digit", minute: "2-digit",
  }).format(new Date(d));
}

export function fmtTime(d) {
  if (!d) return "";
  return new Intl.DateTimeFormat("cs-CZ", { hour: "2-digit", minute: "2-digit" }).format(new Date(d));
}

export function relDay(d) {
  if (!d) return "";
  const date = new Date(d);
  const today = new Date();
  const diff = Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()) -
    new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 86400000);
  if (diff === 0) return "dnes";
  if (diff === 1) return "zítra";
  if (diff === -1) return "včera";
  if (diff < 0) return `před ${Math.abs(diff)} dny`;
  return `za ${diff} dní`;
}

// build local datetime-local input value (YYYY-MM-DDTHH:mm) from Date
export function toInputValue(d) {
  const dt = new Date(d);
  const pad = (n) => String(n).padStart(2, "0");
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
}
